import {
    SHOW_ERROR_MESSAGE,
    SHOW_INFO_MESSAGE,
    UNLOCKETREQUEST_SUCCESSFUL_GET
} from 'reducers/constants';

import HttpClient from "utils/HttpClient/HttpClient";

export const fetchUnlockRequests = (requestData, resolve, reject) => dispatch => {
    new HttpClient(true).get("oga/unlock-request/filter", {
        params: requestData
    })
        .then((response) => {
            dispatch({
                type: UNLOCKETREQUEST_SUCCESSFUL_GET,
                payload: response.data
            });
            resolve();
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
            resolve();
        });
};

export const fetchUnlockRequestInfo = () => dispatch => {
    new HttpClient(true).get("oga/unlockingtaxcommission/info")
        .then((response) => {
            dispatch({
                type: UNLOCKETREQUEST_SUCCESSFUL_GET,
                payload: response.data
            });
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
        });
};

export const saveUnlockRequest = (dto, resolve, reject) => dispatch => {
    new HttpClient(true).post("oga/unlockingtaxcommission/unlock", dto)
        .then((response) => {
            resolve("Successful");
        })
        .catch((error) => {
            dispatch({
                type: SHOW_INFO_MESSAGE,
                payload: error.response.data.message
            });
            reject("Failed");
        })
};


// WEBPACK FOOTER //
// ./src/reducers/unlockrequest/unlockrequestActions.js